/**
 * Project : workspace
 * File    : BusinessConnectionListScree.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.connection

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.businessConnection.viewModel.BusinessConnectionViewModel
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.navigation.NavigationParam
import component.button.DefaultButton
import component.empty.EmptyData
import component.loader.AppLoader
import component.navigation.TopNavBar
import navigation.AppNavigator
import navigation.route.business.store.BusinessStoreNavRoute
import navigation.route.relation.RelationNavRoute
import presentation.screens.business.connection.component.BusinessConnectedCard
import theme.ThemeColor

/**
 * Represents the business connection list screen class.
 */

class BusinessConnectionListScreen() {
    @Composable
     fun Content() {

        val viewModel = BusinessConnectionViewModel()
        val allConnections = viewModel.allData.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.retrieve()
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Connection", NavigationParam(), onBackPress = {
                AppNavigator.shared().goBack()
            })
            AppLoader(viewModel)
            LazyColumn(modifier = Modifier.fillMaxSize().padding(bottom = 8.dp)) {
                item {
                    if (allConnections.value.isEmpty()) {
                        EmptyData(viewModel = viewModel)
                        DefaultButton(
                            "Connect With Other Business",
                            onClick = {
                                AppNavigator.shared().navigate(RelationNavRoute.CREATE)
//                                navigator?.push(CreateBusinessConnectionScreen())
                            })
                    }
                }
                items(allConnections.value.count()) {
                    BusinessConnectedCard(
                        NavigationParam(),
                        allConnections.value[it],
                        viewModel
                    ) { business:Business ->
                        AppNavigator.shared().navigate(BusinessStoreNavRoute.DETAILS)
                    }
                }
            }
        }
    }
}